import { getLegendIconDataUrl } from '@/helpers/leaflet-layer-style-utils'
import { roundUpTo100percent } from '@/helpers/utils'
import hash from 'object-hash'

export default {
  layerStyles: (state) => {
    return state.layerStyles
  },

  /**
   * Словарь данных левой панели
   * Ключ - источник данных (тип сущности)
   * Значение - объект-словарь в котором ключи - идентификаторы объектов, а значения - сами объекты
   * @param {*} state
   * @returns
   */
  dataSourceObjects: (state) => {
    return state.dataSourceObjects
  },

  legendIconByStyleId: (state, getters) => (styleId) => {
    let styleConfig = getters.layerStyles[styleId]
    if (!styleConfig) {
      return null
    }

    if (Array.isArray(styleConfig) && styleConfig[0].style) {
      //Наличие style говорит о том, что у слоя набор правил
      //Пока костыльно возьмем первое правило
      styleConfig = styleConfig[0].style
    }

    //Стиль без правил пока будет рисовать иконку на основе первого стиля
    return getLegendIconDataUrl(styleConfig[0] ? styleConfig[0] : styleConfig, getters.layerIconDictionary)
  },

  legendRulesByStyle: (state, getters) => ({ styleId, inputStyleRules }) => {
    let styleRules = null
    if (styleId) {
      styleRules = getters.layerStyles[styleId]
    } else if (inputStyleRules) {
      styleRules = inputStyleRules
    }

    if (!styleRules) {
      return null
    }

    //Если нет поля style, то у слоя нет набора правил
    if (!Array.isArray(styleRules) || styleRules.length === 0 || !styleRules[0].style) {
      return null
    }

    return styleRules
      .filter((styleRulesItem) => {
        return !styleRulesItem.hideInMapLegend
      })
      .map((styleRulesItem, index) => {
        return {
          id: styleRulesItem.id || index,
          name: styleRulesItem.name || styleRulesItem.id || `Правило ${index}`,
          icon: getLegendIconDataUrl(styleRulesItem.style, getters.layerIconDictionary)
        }
      })
  },

  flowLegendStyleRules: (state, getters) => {
    //Костыль для потоков, id = flow - это хардкод
    const flowLayerSettings = getters.objectLayerSettings['flow']

    //Стилевые правила на основе типов обращения
    const styleRulesByTreatments = getters.treatmentsWithColors.map((treatment) => {
      return {
        id: `treatment_rule_${treatment.id}`,
        name: treatment.ru_name,
        style: {
          type: 'Polyline',
          options: {
            weight: 2,
            color: treatment.color
          }
        }
      }
    })

    //Результирующий массив стилевых правил
    let flowStyleRules = []

    if (flowLayerSettings.showItems && flowLayerSettings.animation) {
      //Стилевые правила в виде кругов для предметов
      const circleStyleRulesByItems = getters.itemsWithColors.map((item) => {
        return {
          id: `item_rule_${item.id}`,
          name: item.name,
          style: {
            type: 'CircleMarker',
            options: {
              radius: 5,
              fillColor: item.color
            }
          }
        }
      })

      //Если есть предметы и анимация,
      // то обозначаем потоки линиями по цвету типа обращения и кругами по типу предмета
      flowStyleRules.push(...styleRulesByTreatments, ...circleStyleRulesByItems)
    } else if (!flowLayerSettings.showItems) {
      //Если отображение предметов отключено, то только линии по типу обращения
      flowStyleRules.push(...styleRulesByTreatments)
    } else {
      //Иначе (нет анимации, но включены предметы, то линии по цвету предмета)
      flowStyleRules.push(
        ...getters.itemsWithColors.map((item) => {
          return {
            id: `item_rule_${item.id}`,
            name: item.name,
            style: {
              type: 'Polyline',
              options: {
                weight: 2,
                color: item.color
              }
            }
          }
        })
      )
    }

    return getters.legendRulesByStyle({ inputStyleRules: flowStyleRules })
  },

  /**
   * Словарь иконок пока полностью храним на фронте
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  layerIconDictionary: (state, getters) => {
    return {
      transportbase: require('@/assets/transportBase.svg'),
      direction: require('@/assets/direction.png'),
      'flow-direction': require('@/assets/flow-direction.svg')
    }
  },

  /**
   * Словарь иконок инфослоев
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  infoLayerIconDictionary: (state) => {
    return state.infoLayerIcons.reduce((result, iconConfig) => {
      result[iconConfig.id] = iconConfig
      return result
    }, {})
  },

  /**
   * Иконка инфослоя по умолчанию
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  defaultInfoLayerIcon: (state, getters) => {
    return getters.infoLayerIconDictionary['infolayer_default']
  },

  availableLayerSettigns: (state) => {
    return Object.values(state.objectLayerSettings)
      .filter((layerSettings) => {
        return !layerSettings.hide
      })
      .sort((layerSettings1, layerSettings2) => {
        return layerSettings1.order - layerSettings2.order
      })
  },

  /**
   * Возвращает true если слой групповой или если слой негрупповой и кол-во объектов больше 0
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  isLayerVisibleByCount: (state, getters) => (layerId) => {
    const childrenLayerSettings = getters.getLayerSettingsByParentId(layerId)

    //Если слой содержит дочерние слои (папка)
    if (childrenLayerSettings.length > 0) {
      return true
    }

    //Для негрупповых слоев смотрим кол-во объектов
    const layerObjects = getters.layerObjects[layerId]
    return layerObjects && layerObjects.count > 0
  },

  /**
   * Получени массива настроек негрупповых слоев (обычные слои)
   * @param {*} state
   * @returns
   */
  simpleLayerSettings: (state, getters) => {
    return getters.availableLayerSettigns.filter((layerSettings) => {
      //Костыль для объектов инфраструктуры. Игнорируем вложенные слои, работаем с корнем
      const isInfrastructureRoot = layerSettings.id === 'infrastructure'
      const isInfrastructureChild = layerSettings.id.includes('infrastructure-')

      return (getters.getLayerSettingsByParentId(layerSettings.id).length <= 0 && !isInfrastructureChild) || isInfrastructureRoot
    })
  },

  /**
   * Специальные режим получения настроек видимых слоев
   * из группы зон берется только первый видимый слой уровня адмнистративного деления
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  visibleSimpleLayerSettingsTreeMode: (state, getters) => {
    return getters.rootLayerSettings.reduce((result, layerSettings) => {
      if (isLayerSimple(layerSettings, getters) && getters.getLayerVisibility(layerSettings.id)) {
        result.push(layerSettings)
      } else {
        result.push(...getVisibleSimpleLayerSettingsTreeMode(layerSettings, getters))
      }
      return result
    }, [])
  },

  /**
   * Специальные режим получения настроек видимых слоев
   * из группы зон берется только первый видимый слой уровня адмнистративного деления
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  visibleSimpleLayerIdsTreeMode: (state, getters) => {
    return getters.visibleSimpleLayerSettingsTreeMode.map((layerSettings) => {
      return layerSettings.id
    })
  },

  rootLayerSettings: (state, getters) => {
    return getters.availableLayerSettigns.filter((layerSettings) => {
      return !layerSettings.parentId
    })
  },

  /**Получение дочерних слоев по идентификатору */
  getLayerSettingsByParentId: (state, getters) => (parentLayerId) => {
    return getters.availableLayerSettigns
      .filter((layerSettings) => {
        return layerSettings.parentId === parentLayerId
      })
      .sort((layerSettings1, layerSettings2) => {
        return layerSettings1.order - layerSettings2.order
      })
  },

  layerIdsFiltredByText: (state, getters) => {
    return getters.rootLayerSettings
      .filter((layerSettings) => {
        return layerSettings.filterByText
      })
      .reduce((result, layerSettings) => {
        return {
          ...result,
          ...getters.getLayerIdsFiltredByText(layerSettings.id, false)
        }
      }, {})
  },

  getLayerIdsFiltredByText: (state, getters) => (layerId, isParentLayerInFilter) => {
    const layerSettings = getters.objectLayerSettings[layerId]
    if (!layerSettings) {
      return {}
    }
    const isLayerInFilter = typeof layerSettings.name === 'string' && layerSettings.name.toUpperCase().includes(getters.layerFilterText)

    const childrenLayerSettings = getters.getLayerSettingsByParentId(layerId)
    if (childrenLayerSettings.length > 0) {
      let childrenLayerIds = childrenLayerSettings.reduce((result, layerSettings) => {
        return {
          ...result,
          ...getters.getLayerIdsFiltredByText(layerSettings.id, isLayerInFilter || isParentLayerInFilter)
        }
      }, {})

      let filterType = null
      const childrenByText = Object.keys(childrenLayerIds).filter((childLayerId) => {
        return ['by-text', 'by-objects'].includes(childrenLayerIds[childLayerId])
      })

      if (childrenByText.length > 0) {
        filterType = 'by-children'
      } else if (isParentLayerInFilter) {
        filterType = 'by-parent'
      } else if (isLayerInFilter) {
        filterType = 'by-text'
      }

      if (filterType) {
        return {
          [layerId]: filterType,
          ...childrenLayerIds
        }
      }

      return {}
    } else {
      let filterType = null
      let layerObjects = []
      if (getters.layerObjects[layerId] && getters.layerObjects[layerId].objects) {
        layerObjects = Object.values(getters.layerObjects[layerId].objects).filter((layerObjectsItem) => {
          if (typeof layerObjectsItem.name !== 'string') {
            return false
          }
          return layerObjectsItem.name.toUpperCase().includes(getters.layerFilterText)
        })
      }

      if (layerObjects.length > 0) {
        filterType = 'by-objects'
      } else if (isLayerInFilter) {
        filterType = 'by-text'
      } else if (isParentLayerInFilter) {
        filterType = 'by-parent'
      }

      if (filterType) {
        return {
          [layerId]: filterType
        }
      }
    }

    return {}
  },

  /**Получение отсортированного массива всех слоев */
  sortedLayerSettingsArray: (state, getters) => (parentId) => {
    return getters.getLayerSettingsByParentId(parentId).reduce((result, layerSettingsItem) => {
      result.push(layerSettingsItem)
      result.push(...getters.sortedLayerSettingsArray(layerSettingsItem.id))
      return result
    }, [])
  },

  /**
   * Словарь: ключ - идентификатор слоя
   * @param {*} state
   * @returns значение - объект {obejcts:{}, count}
   */
  layerObjects: (state) => state.layerObjects,

  /**
   * Словарь объектов слоя левой панели с распределением по типу слоя
   * ключ- type(-serverId при наличии) из настрое слоя
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  layerObjectsByType: (state, getters) => {
    return getters.availableLayerSettigns.reduce((result, layerSettings) => {
      let type = layerSettings.detailInfoType || layerSettings.type
      const serverId = layerSettings.serverId
      if (serverId) {
        type = `${type}-${serverId}`
      }

      if (!result[type]) {
        result[type] = {}
      }

      const layerObjects = getters.layerObjects[layerSettings.id]
      if (layerObjects) {
        result[type] = {
          ...result[type],
          ...layerObjects.objects
        }
      }

      return result
    }, {})
  },

  /**
   * Получение видивости объекта слоя по идентификатору объекта и идентификатору слоя или по типу слоя
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  getLayerObjectVisibility: (state, getters) => ({ layerId = null, layerType = null, layerSubtype = null, layerObjectId }) => {
    //Получение видимости, если передан идентификатор слоя
    if (layerId) {
      const layerObjects = getters.layerObjects[layerId]
      if (!layerObjects || !layerObjects.objects[layerObjectId]) {
        //Если объект не найден в слое, то возвращаем видимость слоя
        return getters.getLayerVisibility(layerId)
      }

      return layerObjects.objects[layerObjectId][getters.objectVisibilityProperty]
    }

    //Получени видимости если передан тип слоя
    if (layerType) {
      let type = layerType
      if (layerSubtype) {
        type = `${type}-${layerSubtype}`
      }

      const layerObjectsByType = getters.layerObjectsByType[type]
      if (!layerObjectsByType || !layerObjectsByType[layerObjectId]) {
        //Если не удалось найти объект по типу, то считаем что он видим
        return true
      }

      return layerObjectsByType[layerObjectId][getters.objectVisibilityProperty]
    }

    return false
  },

  /**Получение флага возможно ли перетаскивать дочерние слои */
  isLayerChildrenDraggable: (state, getters) => (layerId) => {
    const layerSettings = getters.objectLayerSettings[layerId] || {}
    return !layerSettings.hasOwnProperty('childrenDraggable') || layerSettings.childrenDraggable
  },

  getChildrenLayerSettings: (state, getters) => (layerId) => {
    return getters.getLayerSettingsByParentId(layerId) || []
  },

  isGroupLayer: (state, getters) => (layerId) => {
    const layerSettings = getters.objectLayerSettings[layerId]
    return layerSettings && layerSettings.groupLayer
  },

  /**Получение видимости слоя */
  getLayerVisibility: (state, getters) => (layerId) => {
    const childrenLayerSettings = getters.getLayerSettingsByParentId(layerId) || []

    if (childrenLayerSettings.length > 0) {
      return childrenLayerSettings.reduce((result, childLayerSetting) => {
        return result || getters.getLayerVisibility(childLayerSetting.id)
      }, false)
    } else {
      //Если не нашли настроек слоя, то возвращаем что слой невидим
      const layerSettings = getters.objectLayerSettings[layerId]
      if (!layerSettings) {
        return false
      }

      //Если у слоя можно менять видимость отдельных объектов, то видимость слоя это ИЛИ видимости объектов
      const layerObjects = state.layerObjects[layerId]
      if (layerSettings.canToggleItemsVisibility && layerObjects && layerObjects.objects) {
        return Object.values(layerObjects.objects).reduce((result, layerObjectsItem) => {
          return result || layerObjectsItem[getters.objectVisibilityProperty]
        }, false)
      }

      //Видимость слоя
      return layerSettings[getters.objectVisibilityProperty]
    }
  },

  /**Свернут слой или развернут */
  getLayerIsOpen: (state, getters) => (layerId) => {
    if (!getters.objectLayerSettings[layerId]) {
      return false
    }

    return getters.objectLayerSettings[layerId].open
  },

  /**
   * Получение суммарного количества объектов дочерних слоев
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  getChildLayerObjectsCount: (state, getters) => (layerId) => {
    const childrenLayerSettings = getters.getLayerSettingsByParentId(layerId) || []

    if (childrenLayerSettings.length > 0) {
      //Хотел написать return reduce Но из-за этого проект зависал, может ли быть проблема в отсутствии ";"
      const totalChildrenObjectsCount = childrenLayerSettings.reduce((result, childLayerSetting) => {
        result += getters.getChildLayerObjectsCount(childLayerSetting.id)
        return result
      }, 0)
      return totalChildrenObjectsCount
    }

    if (getters.layerObjects[layerId]) {
      return getters.layerObjects[layerId].count || 0
    }

    return 0
  },

  /**
   * Получение всех дочерних объектов слоя
   * Испотльзуется для рисования ОИ
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  getChildLayerObjects: (state, getters) => (layerId) => {
    const childrenLayerSettings = getters.getLayerSettingsByParentId(layerId) || []

    if (childrenLayerSettings.length > 0) {
      //Хотел написать return reduce Но из-за этого проект зависал, может ли быть проблема в отсутствии ";"
      const allChildrenObjects = childrenLayerSettings.reduce((result, childLayerSetting) => {
        return {
          ...result,
          ...getters.getChildLayerObjects(childLayerSetting.id)
        }
      }, {})
      return allChildrenObjects
    }

    if (getters.layerObjects[layerId]) {
      return getters.layerObjects[layerId].objects
    }

    return {}
  },

  /**
   * Получение первого видимого уровня административного деления или первого доступного уровня
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  getSelectedAdmLevel: (state, getters) => {
    let zonegroupLayers = getters.getLayerSettingsByParentId('zonegroup')
    if (getters.objectZoneGroupMode) {
      zonegroupLayers = zonegroupLayers.filter((zonegroup) => zonegroup.default)
    }

    let admLevel = -1
    for (let zonegroupLayerSettings of zonegroupLayers) {
      const admLevelLayers = getters.getLayerSettingsByParentId(zonegroupLayerSettings.id)

      for (let admLevelLayerSettings of admLevelLayers) {
        if (getters.getLayerVisibility(admLevelLayerSettings.id)) {
          return admLevelLayerSettings.admLevel
        }

        if (admLevel < 0) {
          admLevel = admLevelLayerSettings.admLevel
        }
      }
    }

    return admLevel
  },

  /**
   * Получение настроек слоя первого видимого уровня административного деления
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  getFirstVisibleAdmLevelLayerSettings: (state, getters) => {
    const zonegroupLayers = getters.getLayerSettingsByParentId('zonegroup')

    for (let zonegroupLayerSettings of zonegroupLayers) {
      const admLevelLayers = getters.getLayerSettingsByParentId(zonegroupLayerSettings.id)

      for (let admLevelLayerSettings of admLevelLayers) {
        if (getters.getLayerVisibility(admLevelLayerSettings.id)) {
          return admLevelLayerSettings
        }
      }
    }

    return null
  },

  getFirstVisibleAdmLevelLayerSettingsZoneMode: (state, getters) => {
    const zonegroupLayers = getters.getLayerSettingsByParentId('zonegroup').filter((layerSettings) => {
      return !!layerSettings.default
    })

    for (let zonegroupLayerSettings of zonegroupLayers) {
      const admLevelLayers = getters.getLayerSettingsByParentId(zonegroupLayerSettings.id)

      for (let admLevelLayerSettings of admLevelLayers) {
        if (getters.getLayerVisibility(admLevelLayerSettings.id) && admLevelLayerSettings.admLevel < 20) {
          return admLevelLayerSettings
        }
      }
    }

    return null
  },

  /**
   * Получение массива настроек слоев по источнику данных
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  getLayerSettingsByDataSource: (state, getters) => (dataSource) => {
    return getters.availableLayerSettigns
      .filter((layerSettings) => {
        return layerSettings.dataSource === dataSource
      })
      .sort((layerSettings1, layerSettings2) => {
        return layerSettings1.order - layerSettings2.order
      })
  },

  /**
   * Получение массива настроек слоев по типу слоя
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  getLayerSettingsByType: (state, getters) => (type) => {
    return getters.availableLayerSettigns
      .filter((layerSettings) => {
        return layerSettings.type === type
      })
      .sort((layerSettings1, layerSettings2) => {
        return layerSettings1.order - layerSettings2.order
      })
  },

  getLayerSettingsByColoringType: (state, getters) => (coloringType) => {
    return getters.availableLayerSettigns
      .filter((layerSettings) => {
        return layerSettings.coloringType === coloringType
      })
      .sort((layerSettings1, layerSettings2) => {
        return layerSettings1.order - layerSettings2.order
      })
  },

  /**
   * Получить layerId объекта по типу и id, нужно для ОИ, где очень неудобный путь для взаимодействия с объектами
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  getLayerIdByRootTypeAndObjectId: (state, getters) => (type, objectId) => {
    return Object.keys(getters.layerObjects)
      .filter((layerType) => layerType.indexOf(type) === 0)
      .find((layerType) => getters.layerObjects[layerType].objects[objectId])
  },

  /**
   * Получение объекта слоя левой панели по идентификатору слоя и объекта
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  getLayerObject: (state, getters) => (layerId, objectId) => {
    const layerObjects = getters.layerObjects[layerId]
    if (!layerObjects || !layerObjects.objects) {
      return null
    }

    return layerObjects.objects[objectId] || null
  },

  /**Показать маршрут для выбранного объекта линейного информационного слоя */
  showRouteForSelectedStreaminfoObject: (state) => state.showRouteForSelectedStreaminfoObject,

  /**Показать маршрут для выбранной кп */
  showRouteForContainerPlatform: (state) => state.showRouteForContainerPlatform,

  /**
   * Получение типа объекта инфраструктуры по его рангу
   * @param {*} state
   * @returns
   */
  getInfrastructureTypeByRank: (state, getters) => (infrastructureObject) => {
    const infrastructureTypes = getters.settings.infrastructure_type
    const infrastructureTypeByRank = infrastructureTypes.find((infrastructureTypeItem) => {
      return infrastructureObject.rank >= infrastructureTypeItem.min_rank && infrastructureObject.rank < infrastructureTypeItem.max_rank
    })

    if (infrastructureTypeByRank) {
      return infrastructureTypeByRank.label
    }

    return null
  },

  /**
   * Уровень потоков (массив, например [1, 2])
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  flowSelectedLevel: (state, getters) => {
    if (!getters.objectLayerSettings || !getters.objectLayerSettings.flow) {
      return null
    }

    return getters.objectLayerSettings.flow.selectedLevel || null
  },

  /**
   * Показать только потоки, у которых есть выбранные проблемы
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  flowSelectedProblems: (state, getters) => {
    if (!getters.objectLayerSettings || !getters.objectLayerSettings.flow) {
      return null
    }

    return getters.objectLayerSettings.flow.selectedProblems || null
  },

  /**
   * Выбранные типы транспорта (нужно для ОПВК)
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  flowSelectedTransportTypes: (state, getters) => {
    if (!getters.objectLayerSettings || !getters.objectLayerSettings.flow) {
      return null
    }

    return getters.objectLayerSettings.flow.selectedTransportTypes || null
  },

  /**
   * Источники данных доступных слоев (которые не скрыли принудительно через настройку hide)
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  availableLayerDataSources: (state, getters) => {
    return Array.from(
      new Set(
        getters.availableLayerSettigns
          .filter((layerSettings) => {
            return !!layerSettings.dataSource
          })
          .map((layerSettings) => {
            //Костыль для маршрутов
            if (layerSettings.dataSource === 'route') {
              return layerSettings.type
            }

            return layerSettings.dataSource
          })
      )
    )
  },

  /**
   * Получение видимых внутренних источников данных для слоев
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  visibleLayerDataSources: (state, getters) => {
    return Array.from(
      new Set(
        getters.visibleSimpleLayerSettingsTreeMode
          .filter((layerSettings) => {
            return !!layerSettings.dataSource
          })
          .map((layerSettings) => {
            return layerSettings.dataSource
          })
      )
    )
  },

  /**
   * Возвращает true если найден хотя бы один видимы слой по заданному источнику данных
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  getDataSourceVisibility: (state, getters) => (dataSource) => {
    return getters.getLayerSettingsByDataSource(dataSource).reduce((result, layerSettings) => {
      return result || getters.getLayerVisibility(layerSettings.id)
    }, false)
  },

  coloringLayerNames: (state) => {
    return state.coloringLayerNames
  },

  colorings: (state) => {
    return state.colorings
  },

  layerColorings: (state) => {
    return state.layerColorings
  },

  layerColoringConnections: (state) => {
    return state.layerColoringConnections
  },

  rawSelectedObjectInfo: (state) => {
    return state.rawSelectedObjectInfo
  },

  /**
   * Специальный заголовок выбранного объекта
   * сейчас актуально для ОИ и территорий
   */
  selectedObjectName: (state, getters) => {
    if (getters.rawSelectedObjectInfo && typeof getters.rawSelectedObjectInfo === 'object' && getters.objectSelected) {
      if (['infrastructure', 'zone', 'adm_territory', 'dedicated_territory'].includes(getters.objectSelected.type)) {
        return getters.rawSelectedObjectInfo.name
      }

      return
    }

    return null
  },

  /**
   * Получение видимости слоя в левой панели слоев
   * групповой слой не отображается в легенде, если у него не отображаются дочерние слои
   * обычный слой не отображается в легенде если в нем нет объектов (исключение - слой потоков)
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  getLayerPanelVisibility: (state, getters) => (layerId) => {
    const layerSettings = getters.objectLayerSettings[layerId]
    if (!layerSettings) {
      return false
    }

    if (layerSettings.alwaysShowInPanel) {
      return true
    }

    const childrenLayerSettings = getters.getLayerSettingsByParentId(layerId) || []

    //Негрупповой слой
    if (childrenLayerSettings.length === 0) {
      //Получение объектов левой панели слоя
      const layerObjects = getters.layerObjects[layerId] || null

      if (layerSettings.loading) {
        return true
      }

      //Не отображаем в левой панели если нет объектов
      if (!layerObjects) {
        return false
      }

      //Отображаем обычный слой, если есть объекты для левой панели
      const layerObjectsArray = Object.values(layerObjects.objects || {}).filter((layerObject) => !layerObject.isNotFull)
      return layerObjectsArray.length > 0
    }

    //Групповой слой с отображением кол-ва объектов дочерних слоев
    if (layerSettings.showChildLayerObjectsCount) {
      return getters.getChildLayerObjectsCount(layerId) > 0
    }

    //Групповой слой - рекурсивное обращение к геттеру
    return childrenLayerSettings.reduce((result, childLayerSetting) => {
      return result || getters.getLayerPanelVisibility(childLayerSetting.id)
    }, false)
  },

  getLayerLabels: (state, getters) => (layerId) => {
    const layerSettings = getters.objectLayerSettings[layerId] || {}
    return layerSettings.labels || {}
  },

  getFirstDedicatedTerritoryLayerSettings: (state, getters) => {
    //Получим дочерние слои территориального деления
    const zoneGroupChildLayerSettings = getters.getLayerSettingsByParentId('zonegroup')
    if (!zoneGroupChildLayerSettings || !zoneGroupChildLayerSettings[0]) {
      return null
    }

    //Получение массива слоев уровней административного деления
    const admLevelLayerSettingsArray = getters.getLayerSettingsByParentId(zoneGroupChildLayerSettings[0].id)
    if (!Array.isArray(admLevelLayerSettingsArray) || admLevelLayerSettingsArray.length === 0) {
      return null
    }

    //20 - выделенные территории
    //Ищем настройки слоя, у которых есть admLevel === 20
    return (
      admLevelLayerSettingsArray.find((admLevelLayerSettings) => {
        return admLevelLayerSettings.admLevel === 20
      }) || null
    )
  },

  /**
   * Получение дочерних видимых слоев
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  getVisibleChildLayerSettings: (state, getters) => (layerId) => {
    return getters.getLayerSettingsByParentId(layerId).filter((childLayerSettings) => {
      return getters.getLayerVisibility(childLayerSettings.id)
    })
  },

  /**
   * Потоки обычной 2d карты с проблемой и отфильтрованные по территории и проблемам
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  flowLayerMapDataFiltred(state, getters) {
    return getters.getFlowLayerMapDataFiltred({
      flowMapData: getters.objectMapData.flow,
      ...getters.flowFilter
    })
  },

  /**
   * Потоки обычной 2d карты с проблемой, отфильтрованные по территории и проблемам и сгруппированные по линиям
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  flowLayerMapDataFiltredAndGrouped(state, getters) {
    return getFlowLayerMapDataGroupedByLine(getters.flowLayerMapDataFiltred)
  },

  /**
   * Потоки 3d карты с проблемой и отфильтрованные по территории и проблемам
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  flowLayerMapDataFiltred3D(state, getters) {
    return getters.getFlowLayerMapDataFiltred({
      flowMapData: getters.object3DMapData.flow,
      ...getters.flowFilter
    })
  },

  /**
   * Потоки 3d карты с проблемой, отфильтрованные по территории и проблемам и сгруппированные по линиям
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  flowLayerMapDataFiltredAndGrouped3D(state, getters) {
    return getFlowLayerMapDataGroupedByLine(getters.flowLayerMapDataFiltred3D)
  },

  /**
   * Фильтр потоков по проблемама и территории
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  flowFilter: (state, getters) => {
    const flowLayerSettings = getters.objectLayerSettings.flow
    if (!flowLayerSettings) {
      return {
        selectedTerritory: null
      }
    }
    return {
      selectedTerritory: flowLayerSettings.selectedTerritory || null
    }
  },

  /**
   * Функция фильтрации данных карты потоков по проблемам и территории
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  getFlowLayerMapDataFiltred: (state, getters) => ({ flowMapData, selectedTerritory }) => {
    return flowMapData.filter((flowItem) => {
      const filterByTerritory = selectedTerritory ? flowItem.territory && flowItem.territory.id === selectedTerritory.id : true
      return filterByTerritory
    })
  },

  /**
   * Источники обычной 2d карты с отфильтрованные по территории
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  sourceLayerMapData: (state, getters) => {
    return getters.getSourceLayerMapData(getters.objectMapData.source)
  },

  /**
   * Источники 3d карты с отфильтрованные по территории
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  sourceLayerMapData3D: (state, getters) => {
    return getters.getSourceLayerMapData(getters.object3DMapData.source)
  },

  /**
   * Функция фильтрации и объединения источников для карты
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  getSourceLayerMapData: (state, getters) => (sourceMapData) => {
    //Фильтрация источников по территории, если она была выбрана
    const { selectedTerritory } = getters.flowFilter
    const sources = sourceMapData.filter((sourceItem) => {
      const filterByTerritory = selectedTerritory ? sourceItem.territory && sourceItem.territory.id === selectedTerritory.id : true
      return filterByTerritory
    })

    //Получение массива уникальных идентификаторов территорий
    const territoryIds = Array.from(
      new Set(
        sources
          .filter((sourceItem) => {
            return sourceItem.territory
          })
          .map((sourceItem) => {
            return sourceItem.territory.id
          })
      )
    )

    //Сначала оставим источники у которых не указана территория
    let resultSources = sources.filter((sourceItem) => {
      return !sourceItem.territory
    })

    //Добавим в результат  сгруппированные по территориям источники
    territoryIds.forEach((territoryId) => {
      const sourceSubGroup = sources.filter((sourceItem) => {
        return sourceItem.territory && sourceItem.territory.id === territoryId
      })

      //Идентификаторы источников
      const sourceIds = sourceSubGroup.map((sourceItem) => {
        return sourceItem.sources[0]
      })

      //Названия источников
      const sourceNames = sourceSubGroup.map((sourceItem) => {
        return sourceItem.name
      })

      resultSources.push({
        id: sourceSubGroup[0].sources[0],
        name: Array.from(new Set(sourceNames)).join(', '),
        count: sourceIds.length,
        point: {
          type: 'Point',
          coordinates: sourceSubGroup[0].territory.center
        },
        sources: sourceIds
      })
    })

    return resultSources
  },

  getLayerLoadRequestParam: (state, getters) => ({ entity, ...customParams }) => {
    if (!getters.objectsPeriod || !getters.objectsPeriod.borders) {
      return null
    }

    return {
      is_panel: true, //Дополнительный параметр, чтобы игнорировать скрытые поля и корректно отображать названия
      [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.borders.join(','),
      workspace: getters.workspace,
      version: getters.version,
      entities: entity,
      ...customParams
    }
  },

  infrastructureLayerLoadParam: (state, getters) => {
    let customParams = {}
    const flowSelectedProblems = getters.flowSelectedProblems
    if (Array.isArray(flowSelectedProblems) && flowSelectedProblems.length > 0) {
      customParams.problems = flowSelectedProblems.join(',')
    }
    return getters.getLayerLoadRequestParam({ entity: 'infrastructure', ...customParams })
  },

  infrastructureLayerLoadParamHash: (state, getters) => {
    if (!getters.infrastructureLayerLoadParam) {
      return null
    }
    return hash.MD5(getters.infrastructureLayerLoadParam)
  },

  flowLayerLoadParam: (state, getters) => {
    const flowLayerSettings = getters.objectLayerSettings.flow
    if (!flowLayerSettings) {
      return null
    }

    let param = {
      entity: 'flow',
      problems: Array.isArray(getters.flowSelectedProblems) ? getters.flowSelectedProblems.join(',') : null
    }

    if (Array.isArray(getters.flowSelectedTransportTypes)) {
      param.transport_types = getters.flowSelectedTransportTypes.join(',')
    }

    //Уровня потока всего 2: Перевозка и Вывоз
    //Если выбраны оба то ничего не передаем, если выбран только один передаем его значение в параметр level
    const level = getters.flowSelectedLevel
    if (Array.isArray(level) && level.length === 1) {
      param.level = level[0]
    }

    return getters.getLayerLoadRequestParam(param)
  },

  flowLayerLoadParamHash: (state, getters) => {
    if (!getters.flowLayerLoadParam) {
      return null
    }
    return hash.MD5(getters.flowLayerLoadParam)
  },

  sourceLayerLoadParam: (state, getters) => {
    return getters.getLayerLoadRequestParam({
      entity: 'source',
      //TODO: либо бэк должен обработать параметр, либо переделывать на запрос к data
      problems: Array.isArray(getters.flowSelectedProblems) ? getters.flowSelectedProblems.join(',') : null
    })
  },

  sourceLayerLoadParamHash: (state, getters) => {
    if (!getters.sourceLayerLoadParam) {
      return null
    }
    return hash.MD5(getters.sourceLayerLoadParam)
  },

  zoneGroupLayerLoadParam: (state, getters) => {
    return getters.getLayerLoadRequestParam({
      entity: 'zonegroup'
    })
  },

  zoneGroupLayerLoadParamHash: (state, getters) => {
    if (!getters.zoneGroupLayerLoadParam) {
      return null
    }
    return hash.MD5(getters.zoneGroupLayerLoadParam)
  },

  infoLayersLayerLoadParam: (state, getters) => {
    return {
      is_panel: true, //Дополнительный параметр, чтобы игнорировать скрытые поля и корректно отображать названия
      workspace: getters.workspace,
      version: getters.version,
      entities: 'infolayers'
    }
  },

  infoLayersLayerLoadParamHash: (state, getters) => {
    if (!getters.infoLayersLayerLoadParam) {
      return null
    }
    return hash.MD5(getters.infoLayersLayerLoadParam)
  },

  commonLayerLoadParam: (state, getters) => {
    if (!getters.objectsPeriod || !getters.objectsPeriod.borders) {
      return null
    }

    return {
      is_panel: true, //Дополнительный параметр, чтобы игнорировать скрытые поля и корректно отображать названия
      [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.borders.join(','),
      workspace: getters.workspace,
      version: getters.version
    }
  },

  commonLayerLoadParamHash: (state, getters) => {
    if (!getters.commonLayerLoadParam) {
      return null
    }
    return hash.MD5(getters.commonLayerLoadParam)
  },

  defaultLayerLoadEntities: (state, getters) => {
    return getters.availableLayerSettigns
      .map((layerSettings) => {
        return layerSettings.layerLoadEntity
      })
      .filter((layerLoadEntity) => {
        return !!layerLoadEntity
      })
  },

  mapMethodsQueue: (state) => {
    return state.mapMethodsQueue
  },

  layerFilterText: (state) => {
    return (state.layerFilterText || '').toUpperCase()
  },

  openedBySearchLayerIds: (state) => {
    return state.openedBySearchLayerIds
  },

  transportTypes: (state, getters) => {
    const transport_types = getters.settings.transport_types || {
      auto: 'Автомобильный',
      railway: 'Железнодорожный',
      air: 'Авиа',
      water: 'Водный'
    }

    return Object.entries(transport_types).map(([id, label]) => {
      return {
        id,
        label
      }
    })
  }
}

/**
 * Обход дерева и получение настроек видимых негрупповых слоев
 * с учетом того что в группе зон видимым считается только первый видимый уровень адм. деления
 * @param {*} layerSettings
 * @param {*} getters
 * @returns
 */
function getVisibleSimpleLayerSettingsTreeMode(layerSettings, getters) {
  let childrenLayerSettings = getters.getLayerSettingsByParentId(layerSettings.id)

  //Это специальная ветка для режима редактирования зон
  if (getters.objectZoneGroupMode && layerSettings.id === 'zonegroup') {
    //Определение выбранного уровня тер деления
    const firstVisibleAdmLevelLayerSettings = getters.getFirstVisibleAdmLevelLayerSettingsZoneMode
    if (!firstVisibleAdmLevelLayerSettings) {
      return []
    }

    const zoneGroupLayerSettingsArray = childrenLayerSettings.filter((layerSettingsItem) => {
      return !layerSettingsItem.default
    })

    //Поиск уровня в группах зон, который соответствует выбранному
    for (let zoneGroupLayerSettings of zoneGroupLayerSettingsArray) {
      const admLevelLayerSettingsArray = getters.getLayerSettingsByParentId(zoneGroupLayerSettings.id)
      for (let admLevelLayerSettings of admLevelLayerSettingsArray) {
        if (
          admLevelLayerSettings.admLevel === firstVisibleAdmLevelLayerSettings.admLevel &&
          getters.getLayerVisibility(admLevelLayerSettings.id) &&
          getters.getLayerSettingsByParentId(admLevelLayerSettings.id).length > 0
        ) {
          //В результат идет только ветка первого видимого слоя адм деления
          return [
            ...getVisibleSimpleLayerSettingsTreeMode(firstVisibleAdmLevelLayerSettings, getters),
            ...getVisibleSimpleLayerSettingsTreeMode(admLevelLayerSettings, getters)
          ]
        }
      }
    }
    return []
  }

  //Обработка группового слоя группы зон
  if (layerSettings.isZoneGroup) {
    for (let childLayerSettingsItem of childrenLayerSettings) {
      if (getters.getLayerVisibility(childLayerSettingsItem.id)) {
        //В результат идет только ветка первого видимого слоя адм деления
        return getVisibleSimpleLayerSettingsTreeMode(childLayerSettingsItem, getters)
      }
    }
    return []
  }

  return childrenLayerSettings.reduce((result, childLayerSettingsItem) => {
    if (isLayerSimple(childLayerSettingsItem, getters) && getters.getLayerVisibility(childLayerSettingsItem.id)) {
      result.push(childLayerSettingsItem)
    } else {
      result.push(...getVisibleSimpleLayerSettingsTreeMode(childLayerSettingsItem, getters))
    }
    return result
  }, [])
}

function isLayerSimple(layerSettings, getters) {
  //Костыль для объектов инфраструктуры. Игнорируем вложенные слои, работаем с корнем
  const isInfrastructureRoot = layerSettings.id === 'infrastructure'
  const isInfrastructureChild = layerSettings.id.includes('infrastructure-')

  return (getters.getLayerSettingsByParentId(layerSettings.id).length <= 0 && !isInfrastructureChild) || isInfrastructureRoot
}

function getFlowLayerMapDataGroupedByLine(flows) {
  const flowsWithLineHash = flows.map((flowItem) => {
    const line = {
      type: 'LineString',
      coordinates: [flowItem.territory ? flowItem.territory.center : flowItem.line.coordinates[0], flowItem.line.coordinates[1]]
    }

    return {
      ...flowItem,
      line,
      lineHash: hash.MD5(line)
    }
  })

  const flowsGroupedByLine = flowsWithLineHash.reduce((result, flowItem) => {
    if (!result[flowItem.lineHash]) {
      result[flowItem.lineHash] = []
    }
    result[flowItem.lineHash].push(flowItem)
    return result
  }, {})

  return Object.values(flowsGroupedByLine).map((flowGroup) => {
    //Идентификаторы потоков группы
    const flowIds = flowGroup.map((flowItem) => {
      return flowItem.id
    })

    //Проблемы потоков группы
    const flowProblems = flowGroup.reduce((result, flowItem) => {
      if (Array.isArray(flowItem.problems)) {
        result.push(...flowItem.problems)
      }
      return result
    }, [])

    //Названия потоков по названию источника
    const flowNames = flowGroup.map((flowItem) => {
      return flowItem.source
    })

    //Суммарная доля от общей массы источника, которая приходится на потоки
    const massPortionSum = flowGroup.reduce((result, flowItem) => {
      return result + flowItem.mass_portion
    }, 0)
    //Средняя доля на группу потоков линии
    const avgMassPortion = massPortionSum / flowGroup.length

    //Сумма масс
    const massSum = flowGroup.reduce((result, flowItem) => {
      result += flowItem.mass || 0
      return result
    }, 0)

    //Сумма объемов
    const volumeSum = flowGroup.reduce((result, flowItem) => {
      result += flowItem.volume || 0
      return result
    }, 0)

    //Определение распределения предметов для линии нескольких потоков
    //Словарь предметов
    const itemsDictionary = flowGroup.reduce((result, flowItem) => {
      return flowItem.items.reduce((itemsResult, item) => {
        if (!itemsResult[item.item_id]) {
          itemsResult[item.item_id] = {
            ...item,
            item_ratio: (item.item_ratio * flowItem.mass) / massSum
          }
        } else {
          itemsResult[item.item_id].item_ratio += (item.item_ratio * flowItem.mass) / massSum
        }

        return itemsResult
      }, result)
    }, {})
    //Массив предметов
    let itemsArray = Object.values(itemsDictionary)
    //Специальное округление, чтобы сумма давала 100%
    const itemRatioUpTo100 = roundUpTo100percent(itemsArray, 'item_ratio')
    //Простановка строки с процентным содержанием предмета в поле item_ratio
    itemsArray.forEach((itemsArrItem, index) => {
      itemsArrItem.ratio = itemsArrItem.item_ratio
      itemsArrItem.item_ratio = `${itemRatioUpTo100[index]}%`
    })

    let resultItem = {
      id: flowGroup[0].id,
      color: flowGroup[0].color,
      treatment_color: flowGroup[0].treatment_color,
      items: itemsArray,
      problems: Array.from(new Set(flowProblems)),
      mass: massSum,
      mass_designation: flowGroup[0].mass_designation || '', //Базовая единица измерения массы
      mass_portion: avgMassPortion,
      volume: volumeSum,
      volume_designation: flowGroup[0].volume_designation || '', //Базовая единица измерения объема
      line: flowGroup[0].line,
      level: flowGroup[0].level, //flowGroup[0] это может привести к багу, если совпадут координаты ОИ и источника
      destination: flowGroup[0].destination,
      destination_rank: flowGroup[0].destination_rank,
      source_id: flowGroup[0].source_id,
      source_rank: flowGroup[0].source_rank,
      source: Array.from(new Set(flowNames)).join(', '),
      flows: flowIds
    }

    return resultItem
  })
}



// WEBPACK FOOTER //
// ./src/store/objects/gettersNewStructure.js